import { useState } from 'react';

import { contacatInfo } from '@entities/company';
import { useGoftinoChat } from '@shared/hooks';
import { useHeaderSheetOpenStore } from '@shared/store';
import { useRouter } from 'next/navigation';

export const useSupportWidget = () => {
  const { widgetSrc, openChat } = useGoftinoChat();
  const router = useRouter();
  const { data, setter } = useHeaderSheetOpenStore();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isTicketDrawerIsOpen, setTicketDrawerIsOpen] = useState(false);
  const [isFeedbackDrawerIsOpen, setFeedbackDrawerIsOpen] = useState(false);

  const openPhoneCall = () => {
    window.location.href = `tel:${contacatInfo.phoneNumber}`;
    setIsDrawerOpen(false);
  };

  const openOnlineChat = () => {
    openChat();
    setIsDrawerOpen(false);
  };

  const openTicketDrawer = () => {
    setTicketDrawerIsOpen(true);
    setIsDrawerOpen(false);
  };
  const openFeedBackDrawer = () => {
    setFeedbackDrawerIsOpen(true);
    setIsDrawerOpen(false);
  };

  const goToSupportCenter = () => {
    router.push('/support');
    setIsDrawerOpen(false);
    if (data) setter(false);
  };

  return {
    isTicketDrawerIsOpen,
    widgetSrc,
    setTicketDrawerIsOpen,
    isDrawerOpen,
    isFeedbackDrawerIsOpen,
    setFeedbackDrawerIsOpen,
    setIsDrawerOpen,
    openPhoneCall,
    openOnlineChat,
    openFeedBackDrawer,
    openTicketDrawer,
    goToSupportCenter,
  };
};
